export default __webpack_public_path__ + "static/media/Close.5e98b123.png";